import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { inkLight } from '../../styles/design-tokens';
import { Tooltip } from '../../ui-library/tooltip/tooltip';
import { Text } from '../../ui-library/typography/typography';
import { LineChartLegendMarker } from './line-chart-legend-marker';

interface Props {
  value: string;
  label: string;
  color: string;
  isHovered: boolean;
  onMouseEnter: (itemId: string) => void;
  onMouseLeave: () => void;
  hasData?: boolean;
  fullLabel?: string;
  enableTooltip?: boolean;
}

export const LineChartLegendItem = ({
  value,
  label,
  color,
  isHovered,
  hasData,
  onMouseEnter,
  onMouseLeave,
  fullLabel,
  enableTooltip = false,
}: Props) => {
  const { t } = useTranslation();

  const noData = hasData !== undefined && hasData === false;
  const showTooltip = enableTooltip || noData;
  const tooltipLabel = noData ? t('common.labels.no_data_for_item') : (fullLabel ?? label);

  return (
    <Tooltip
      label={tooltipLabel}
      position="top"
      variant="white"
      disabled={!showTooltip}
      multiline
      maw={280}
      w="max-content"
    >
      <Flex
        key={value}
        align="center"
        gap={4}
        style={{
          cursor: noData ? 'default' : 'pointer',
          opacity: isHovered ? 1 : 0.3,
          transition: 'opacity 0.2s ease',
        }}
        onMouseEnter={() => onMouseEnter(value)}
        onMouseLeave={onMouseLeave}
      >
        <LineChartLegendMarker color={noData ? inkLight : color} />
        <Text size="tiny">{label}</Text>
      </Flex>
    </Tooltip>
  );
};
